<template>
  <el-row type="flex" justify="center">
    <el-form class="pwd-verification" :rules="rules" label-position="right" label-width="100px"
             :model="pwdVerification" ref="pwdVerification">
      <el-form-item label="输入新密码" prop="pwd">
        <el-input type="password" v-model="pwdVerification.pwd" placeholder="输入新密码"
                  @keyup.native.enter="onSubmit"></el-input>
      </el-form-item>
      <el-form-item label="再输入一次" prop="newpwd">
        <el-input type="password" v-model="pwdVerification.newpwd" placeholder="再输入一次"
                  @keyup.native.enter="onSubmit">
        </el-input>
      </el-form-item>
      <el-form-item class="btn-group">
        <el-button type="primary" @click="submitForm('pwdVerification')" :loading="submitbtn.loading">提交
        </el-button>
        <el-button @click="resetForm('pwdVerification')">重置</el-button>
      </el-form-item>
    </el-form>
  </el-row>
</template>

<script>
import { newPasswordConfirm } from 'api/MobileVeriCode'

export default {
  data () {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback('请输入密码')
      } else {
        if (this.pwdVerification.newpwd !== '') {
          this.$refs.pwdVerification.validateField('newpwd')
        }
        callback()
      }
    }
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback('请再次输入密码')
      } else if (value !== this.pwdVerification.pwd) {
        callback('两次输入密码不一致!')
      } else {
        callback()
      }
    }
    return {
      currentSteps: 2,
      pwdVerification: {
        pwd: '',
        newpwd: '',
      },
      submitbtn: {
        loading: false,
      },
      rules: {
        pwd: [
          {validator: validatePass, trigger: 'blur'},
        ],
        newpwd: [
          {validator: validatePass2, trigger: 'blur'},
        ],
      },
    }
  },
  props: ['steps'],
  methods: {
    async submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) return
        try {
          this.submitbtn.loading = true
          await newPasswordConfirm(this.pwdVerification)
          this.submitbtn.loading = false
          this.$message('密码重置成功')
          this.$emit('update:steps', this.currentSteps + 1)
        } catch (e) {
          this.$handleError(e)
          this.submitbtn.loading = false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
  },
}
</script>

<style scoped lang="scss">
@import "src/scss/var/colors";

.pwd-verification {
  margin-top: 60px;
}

.btn-group {
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/password/step2.vue